import { IonicModule } from '@ionic/angular';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DuelistsListComponent } from './duelists-list.component';
import { DuelistsListComponentRoutingModule } from './duelists-list-routing.module';
import { HelpersModule } from '../../helpers/helpers.module';
@NgModule({
	imports: [IonicModule, CommonModule, FormsModule, DuelistsListComponentRoutingModule, HelpersModule],
	declarations: [DuelistsListComponent],
	exports: [DuelistsListComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DuelistsListModule {}
